import { jsx as _jsx } from "react/jsx-runtime";
function SvgIconmonstrXMark1(props) {
    return (_jsx("svg", Object.assign({ width: 24, height: 24 }, props, { children: _jsx("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282L20.188 0l-8.212 8.318L3.666.115 0 3.781l8.321 8.24-8.206 8.313L3.781 24l8.237-8.318 8.285 8.203z" }) })));
}
export default SvgIconmonstrXMark1;
